var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-bar"},[_c('p',{staticClass:"words"},[_vm._v(_vm._s(_vm.globalError))])])
}
var staticRenderFns = []

export { render, staticRenderFns }